















































































import 'vue-awesome/icons/filter'
import 'vue-awesome/icons/search'

export default
  name: 'transactions_filters'
  props: ['all_trs', 'mode']
  data: ->
    filter_visible: !HM.is_mobile
  computed:
    filter:
      get: -> @$store.state.ui.transactions[@mode].filter
      set: (val) -> @$store.state.ui.transactions[@mode].filter = val
    available_categories: ->
      res = @$store.getters.find_transactions_categories(@all_trs)
      _.map res, (category) ->
        name: category.name
        value: category.name
        count: category.count
    default_filter: -> @$store.state.ui.transactions.filter_default_value
    filter_changed: -> !_.isEqual(@filter, @default_filter)
    category:
      get: -> @filter.category
      set: (value) -> @setFilter { category: value }
    description_match:
      get: -> @filter.description_match
      set: (value) -> @debouncedSetFilter({ description_match: value })
    tr_type:
      get: -> @filter.type
      set: (value) -> @setFilter { type: value }
    account_id:
      get: -> @filter.account_id
      set: (value) -> @setFilter { account_id: value }
    virtual_id:
      get: -> @filter.virtual_id
      set: (value) -> @setFilter { virtual_id: value }
  methods:
    debouncedSetFilter: (condition) ->
      @debouncedFn ||= _.debounce @setFilter, 300
      @debouncedFn(condition)
    setFilter: (condition) -> @$store.commit "TRANSACTIONS/#{@mode.toUpperCase()}/SET_FILTER", condition
    resetFilter: -> @$store.commit "TRANSACTIONS/#{@mode.toUpperCase()}/RESET_FILTER"
